import { createReducer, on } from '@ngrx/store';
import { CityModel } from 'src/app/models/city.model';
import { LocationActions } from '../actions';

export interface LocationState {
  loading: boolean;
  cities: CityModel[];
}

const initialState: LocationState = {
  loading: false,
  cities: [],
}

export const locationReducers = createReducer(
  initialState,
  on(LocationActions.loadCities, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(LocationActions.loadCitiesSuccess, (state, { cities }) => {
    return {
      ...state,
      cities,
      loading: false,
    };
  }),
);
